
































































































































































































































































































































import { Component, Mixins } from "vue-property-decorator";
import AxiosMixin from "@/mixins/axiosMixin";
import UtilMixin from "@/mixins/utilMixin";
import { PREFECTURES } from "@/consts/const";
import AppAuthButton from "@/components/admin_common/AppAuthButton.vue";
import { PORTAL_JOBSEARCH_RECRUITEE_WORK_EMPLOYMENT_TYPE } from "@/consts/portal";

@Component({
  components: {
    AppAuthButton,
  },
})
export default class extends Mixins(AxiosMixin, UtilMixin) {
  /** 初回ロード完了フラグ */
  private initLoadingDone = false;
  private item = null;
  private extraInfo = null;
  private works = [];
  /** 都道府県一覧 */
  private PREFECTURES = PREFECTURES;
  private PORTAL_JOBSEARCH_RECRUITEE_WORK_EMPLOYMENT_TYPE =
    PORTAL_JOBSEARCH_RECRUITEE_WORK_EMPLOYMENT_TYPE;

  public async created() {
    await this.fetchItem(Number(this.$route.params.id));
    this.initLoadingDone = true;
  }

  /** 情報取得 */
  private async fetchItem(id: number) {
    return new Promise((resolve) => {
      this.postJsonCheck(
        window.base_url + "/api/admin/portal_jobsearch_recruitee/get",
        { jobsearch_recruitee_id: id },
        (res) => {
          this.item = res.data.recruitee;
          this.extraInfo = res.data.recruitee_extra_info;
          this.works = res.data.recruitee_works;
          resolve(0);
        }
      );
    });
  }

  //カエドキ代理ログイン
  private jobsearchAgentLogin(id: number) {
    this.postJsonCheck(
      window.base_url +
        "/api/admin/portallogin/jobsearch-recruitee-agent-login",
      {
        recruitee_id: id,
      },
      (res) => {
        window.open(
          window.kaedoki_url +
            "/job-application/signin?token=" +
            res.data.onetime_token,
          "_blank"
        );
      }
    );
  }
}
